import { useEffect, useState } from "react";

import { WipDetailsViewModel } from "../../viewmodels/wips/WipDetailsViewModel";

import { connect } from "react-redux";

import * as actions from "../../store/actions/index";

import { withRouter } from "../../shared/utility";

import EmptyModal from "../../components/modals/EmptyModal";
import SlideOver from "../../components/slideOver/SlideOver";

import { useParams } from "react-router-dom";
import CreateWipForm from "../../components/forms/wips/CreateWipForm";
import { RecordLoadingSkeleton } from "../../components/shared/ContentLoadingSkeleton";
function WipDetails(props) {
  const { addSnackbar, logout } = props;

  const { wipId } = useParams();
  const [initialLoading, setInitialLoading] = useState(true);

  const {
    emptyModal,
    setEmptyModelOpen,
    roomOptions,
    getRoomOptionsForDropdown,
    wip,
    onAddItemToWipByBarcode,
    getRemoveReasonsOptionsForDropdown,
    updateWip,
    getWipDetails,
    openSlideForManufacturedItemDetails,
    setSlideOver,
    slideOver,
    onAskReturnIncomingItem,
    onAskDeleteWipOutputItem,
    openAddPriceGroupModal,
    setOutgoingSelectedItems,
    outgoingSelectedItems,
    incomingReturnItems,
    setIncomingReturnItems,
    askReturnSelectedIncomingItems,
    outgoingDeleteItems,
    setOutgoingDeleteItems,
    askDeleteSelectedOutgoingItems,
    calculateCostForWipOutgoingItems,
    printWipDetailsReport,
    printWipSummaryReport,
    printWipDerivativesReport,
    showError,
    loadingRows,
    rowDetails,
    fetchSubRowDetails,
    subRowDetails,
    subLoadingRows,
    fetchRowDetails,
    fetchOutgoingRowDetails,
    outgoingLoadingRows,
    outgoingRowDetails,
    fetchOutgoingSubRowDetails,
    outgoingSubRowDetails,
    outgoingSubLoadingRows,
    setOutgoingRowDetails,
    setOutgoingSubRowDetails,
    onWipItemTotalCostEditComplete,
  } = WipDetailsViewModel(logout, wipId, addSnackbar);

  const getInfoForWip = async function () {
    try {
      await Promise.all([
        getRoomOptionsForDropdown(),
        getRemoveReasonsOptionsForDropdown(),
      ]);
      await getWipDetails();
    } finally {
      setInitialLoading(false);
    }
  };

  useEffect(() => {
    getInfoForWip();
  }, []);

  return (
    <div>
      <div className="mt-2 px-4 sm:px-8">
        {initialLoading ? (
          <RecordLoadingSkeleton />
        ) : (
          <CreateWipForm
            isEdit={true}
            wip={wip}
            roomOptions={roomOptions}
            onAddItemToWipByBarcode={onAddItemToWipByBarcode}
            updateWip={updateWip}
            openSlideForManufacturedItemDetails={
              openSlideForManufacturedItemDetails
            }
            onAskReturnIncomingItem={onAskReturnIncomingItem}
            onAskDeleteWipOutputItem={onAskDeleteWipOutputItem}
            openAddPriceGroupModal={openAddPriceGroupModal}
            setOutgoingSelectedItems={setOutgoingSelectedItems}
            outgoingSelectedItems={outgoingSelectedItems}
            incomingReturnItems={incomingReturnItems}
            setIncomingReturnItems={setIncomingReturnItems}
            askReturnSelectedIncomingItems={askReturnSelectedIncomingItems}
            outgoingDeleteItems={outgoingDeleteItems}
            setOutgoingDeleteItems={setOutgoingDeleteItems}
            askDeleteSelectedOutgoingItems={askDeleteSelectedOutgoingItems}
            calculateCostForWipOutgoingItems={calculateCostForWipOutgoingItems}
            printWipDetailsReport={printWipDetailsReport}
            printWipSummaryReport={printWipSummaryReport}
            showError={showError}
            printWipDerivativesReport={printWipDerivativesReport}
            loadingRows={loadingRows}
            rowDetails={rowDetails}
            fetchSubRowDetails={fetchSubRowDetails}
            subRowDetails={subRowDetails}
            subLoadingRows={subLoadingRows}
            fetchRowDetails={fetchRowDetails}
            onWipItemTotalCostEditComplete={onWipItemTotalCostEditComplete}
            setEmptyModelOpen={setEmptyModelOpen}
            outgoing={{
              fetchOutgoingRowDetails: fetchOutgoingRowDetails,
              outgoingLoadingRows: outgoingLoadingRows,
              outgoingRowDetails: outgoingRowDetails,
              fetchOutgoingSubRowDetails: fetchOutgoingSubRowDetails,
              outgoingSubRowDetails: outgoingSubRowDetails,
              outgoingSubLoadingRows: outgoingSubLoadingRows,
              setOutgoingRowDetails: setOutgoingRowDetails,
              setOutgoingSubRowDetails: setOutgoingSubRowDetails,
          }}
          />
        )}
      </div>

      <EmptyModal
        childComponent={emptyModal.childComponent}
        open={emptyModal.open}
        setOpen={setEmptyModelOpen}
      />
      <SlideOver
        childComponent={slideOver.childComponent}
        slideOver={slideOver}
        setSlideOver={setSlideOver}
        customClass="max-w-3xl"
      />
    </div>
  );
}

const mapStateToProps = (state) => {
  return {};
};

const mapDispatchToProps = (dispatch) => {
  return {
    logout: () => dispatch(actions.logout()),
    addSnackbar: (snackbar) => dispatch(actions.addSnackbar(snackbar)),
  };
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(WipDetails),
);
